import { render } from "./Tooltip.vue?vue&type=template&id=694b0544"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"
script.render = render

export default script